import React from 'react';
import { useShopifyProducts } from '../../../hooks/useShopify';

interface SwatchProps {
  metafields: any
  productHandle: string
}

const Swatches: React.FC<SwatchProps> = ({ metafields, productHandle }) => {
  const siblings = React.useMemo(() => metafields.filter((metafield) => metafield.key === 'siblings'), [metafields]);
  const additionalSiblings = React.useMemo(() => metafields.filter((metafield) => metafield.key === 'additional_siblings'), [metafields]);

  if (!siblings.length) return null;

  const parsedSiblings = React.useMemo(() => {
    try {
      return JSON.parse(siblings[0]?.value);
    } catch (error) {
      return [];
    }
  }, [siblings]);
  const publishedSiblings = React.useMemo(() => parsedSiblings.filter((sibling) => sibling.published), [parsedSiblings]);

   const parsedAdditionalSiblings = React.useMemo(() => {
    try {
      return JSON.parse(additionalSiblings[0]?.value);
    } catch (error) {
      return [];
    }
  }, [additionalSiblings]);

  let sibling_handles_count = 0;
  parsedSiblings.forEach((sibling) => {
    if (sibling.published) {
      sibling_handles_count++;
    }
  });

  if (parsedAdditionalSiblings.length) {
    sibling_handles_count += parsedAdditionalSiblings.length;
  }

  const { products: additionalSiblingProducts, loading, error } = useShopifyProducts(parsedAdditionalSiblings || []);
  
  const tagPrefix = 'x-colourName:';

  if (sibling_handles_count === 0 || sibling_handles_count === 1) return null;

  return (
    <>
      <div className="flex-container align-middle gap-8 py-16 swatches-wrapper product-card-swatches-new">
      {publishedSiblings.slice(0, 10).map((sibling, index) => {
          if (!sibling.published) return null;

          let swatchTag = '';
          const matchingTag = sibling.tags.find(tag => tag.includes(tagPrefix));
          if (matchingTag) {
            swatchTag = matchingTag
              .replace(tagPrefix, 'swatch-')
              .replace(' / ', '-')
              .replace('/', '-')
              .replace(' ', '-')
              .replace('--', '-')
              .trim()
              .toLowerCase();
          }

          return (
            <a 
              key={index}
              href={`/products/${sibling.handle}`} 
              title={swatchTag}
              aria-label={swatchTag}
              className={`swatch-item ${sibling.handle === productHandle ? 'active disabled' : ''}`} 
              style={{ backgroundImage: `url('https://cdn.shopify.com/s/files/1/0070/8925/8614/files/${swatchTag}.png')` }}
            ></a>
          );
        })}
       {
        additionalSiblingProducts?.map((product, index) => {
          if (!product) return null;
          if(!product?.availableForSale) return null;

          let swatchTag = '';
          const matchingTag = product.tags.find(tag => tag.includes(tagPrefix));
          if (matchingTag) {
            swatchTag = matchingTag.replace(tagPrefix, 'swatch-');
          }

          return (
            <a 
              key={index}
              href={`${product?.onlineStoreUrl}`} 
              title={swatchTag}
              aria-label={swatchTag}
              className="swatch-item"
              style={{ backgroundImage: `url('https://cdn.shopify.com/s/files/1/0070/8925/8614/files/${swatchTag}.png')` }}
            ></a>
          );
        })
       }
      </div>
      {sibling_handles_count > 1 && (
        <div className="swatch-count text-sm secondary-grey mb-4">+ {sibling_handles_count - 1}  {sibling_handles_count - 1 <= 1 ? `more colour` : `more colours` }</div>
      )}
    </>
  );
};

export default Swatches;